module.exports = "<app-top-nav [_isLoggedIn]=\"_appLoggedIn\"></app-top-nav>\n<router-outlet></router-outlet>\n<app-footer></app-footer>"